export default __webpack_public_path__ + "static/media/maypay_icon_x_gray.60e8242b.svg";